<script setup>
    import { computed } from 'vue';
    import { TinyPumperIncident } from '@/enums/TinyPumper';

    const props = defineProps({
        incidents: Array
    });

    const getIncidents = computed(() =>
        (props.incidents || []).map(incident => ({
            text: TinyPumperIncident[incident] || '-'
        }))
    );
</script>

<template>
    <div class="overflow-auto" style="max-height: 20rem">
        <div
            v-for="(incident, i) in getIncidents"
            :key="`incidents-${i}`"
            class="alert alert-danger d-flex align-items-baseline gap-3 mb-3"
        >
            <i class="bi bi-chat-right-text-fill text-danger"></i>
            <p class="mb-0">{{ incident.text }}</p>
        </div>
        <div v-if="!getIncidents.length" class="card card-body text-center py-4 bg-light">No incidents registered ✅</div>
    </div>
</template>
